<template>
	<div class="relative !px-4 !py-16 flex flex-col gap-4 items-center !container mx-auto !max-w-seint">
		<button
			type="button"
			aria-label="Go Back"
			@click="handleBackStep"
			class="inline-flex items-center absolute left-4 top-5 gap-2 text-[11px]/[14px] uppercase font-medium"
		>
			<svg-vue icon="back-arrow" />
			<span>Back</span>
		</button>
		<template v-if="levelId < 7">
			<h1 class="!m-0 !p-0 font-butler-light text-3xl/[38px] font-light text-center">
				What type of powder finish do you like?
			</h1>
			<ul class="flex flex-col gap-3 w-full max-w-[400px] mx-auto !m-0 !p-0">
				<li v-for="option in powderTypeOptions" :key="option">
					<button
						type="button"
						aria-label=""
						@click="() => handleNextStep(option.name, option.value)"
						:class="[
							'flex flex-col items-center justify-center',
							'w-full !p-3',
							'seint-border hover:ring-2 hover:ring-light-gray-900 hover:dark:ring-white',
							powderTypeName === option.name ? 'ring-2 ring-black' : 'border-brand-solid',
						]"
					>
						<span class="text-sm">{{ option.name }}</span>
						<span class="text-xs/[18px] max-w-80">
							{{ option.description }}
						</span>
					</button>
				</li>
			</ul>
		</template>
		<template v-else>
			<h1 class="!m-0 !p-0 font-butler-light text-3xl/[38px] font-light">Do you like to use powder?</h1>
			<ul class="flex flex-col w-full max-w-[400px] mx-auto gap-3 !m-0 !p-0">
				<li v-for="option in powderUseOptions" :key="option">
					<button
						type="button"
						aria-label=""
						@click="() => handleNextStep(option.name, option.value)"
						:class="[
							'flex flex-col items-center justify-center',
							'w-full !p-3',
							'seint-border hover:ring-2 hover:ring-light-gray-900 hover:dark:ring-white',
							powderTypeName === option.name ? 'ring-2 ring-black' : 'border-brand-solid',
						]"
					>
						<span class="text-sm">{{ option.name }}</span>
					</button>
				</li>
			</ul>
		</template>
	</div>
</template>
<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
	levelId: {
		type: Number,
	},
	powderTypeName: {
		type: String,
		default: null,
	},
	setPowderTypeName: {
		type: Function,
		required: true,
	},
	setPowderTypeId: {
		type: Function,
		required: true,
	},
	setStep: {
		type: Function,
		required: true,
	},
})
const powderTypeOptions = ref([
	{
		name: 'Matte',
		value: 1,
		description: 'A smooth, shine-free finish that minimizes pores, controls oil, and creates a polished, soft look.',
	},
	{
		name: 'Radiant / Glowy',
		value: 2,
		description:
			'A translucent, blurred finish that minimizes fine lines and pores while setting makeup without adding texture.',
	},
	{
		name: 'None',
		value: 0,
		description: 'I prefer a cream only look',
	},
])
const powderUseOptions = ref([
	{
		name: 'Yes, I use it daily',
		value: 1,
	},
	{
		name: 'Sometimes, depending on the look',
		value: 2,
	},
	{
		name: 'No, I prefer a cream-only look',
		value: 0,
	},
])

onMounted(() => {
	window.scrollTo(0, 0)
})

const handleBackStep = () => props.setStep(3)
const handleNextStep = (selectionName, selectionId) => {
	props.setPowderTypeName(selectionName)
	props.setPowderTypeId(selectionId)
	props.setStep(5)
}
</script>
